import { isEmpty } from "lodash";
import { useExportWizardModalContext } from "PFApp/booking/parts/reports/top_actions_panel/export_wizard/export_wizard_modal_provider";
import { ExportType } from "PFApp/booking/types/export_booking";
import { Template } from "PFApp/booking/types/manage_reports";
import { Select } from "PFComponents/select/select";
import { Collection } from "PFTypes";
import React, { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { getTemplateReportType } from "../../helpers";
import css from "./template_selector.module.scss";

interface TemplateSelectorProps {
  disabled?: boolean;
  templates: Collection<Template[]> | undefined;
}

export const TemplateSelector = ({ disabled, templates }: TemplateSelectorProps) => {
  const {
    updateData,
    state: {
      data: { selectedTemplate }
    }
  } = useExportWizardModalContext();

  const { t } = useTranslation("bookingModule", { keyPrefix: "reports.exportWizard" });

  const options = useMemo(
    () =>
      (templates?.entries || []).map((template) => ({
        id: template.id,
        item: template,
        displayElement: (
          <div className={css.dropdownValue} key={template.id}>
            <span title={template.name}>{template.name}</span>
            <span>{t(`reportTypes.${getTemplateReportType(template)}`)}</span>
          </div>
        )
      })),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [templates]
  );

  const selectedIndex = useMemo(
    () => options.findIndex(({ id }) => id === selectedTemplate?.id),
    [options, selectedTemplate]
  );

  useEffect(() => {
    if (templates && isEmpty(options)) {
      updateData({
        exportType: ExportType.Custom
      });
      return;
    }
    if (!selectedTemplate && options?.[0]) {
      handleSelectedTemplateChange(options[0].item);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [options]);

  const handleSelectedTemplateChange = (value: Template) => {
    updateData({
      selectedTemplate: value
    });
  };

  return (
    <Select
      /* @ts-ignore */
      readOnly
      controlledValue
      kind="bordered"
      className={css.select}
      disabled={disabled}
      options={options}
      handleChange={handleSelectedTemplateChange}
      selectedIndex={selectedIndex}
      displayValues={selectedTemplate?.name}
    />
  );
};
